const prices = {
    PLN: 100,
    GBP: 20,
    USD: 30,
    EUR: 25,
    RUB: 2000,
    RON: 120,
    CZK: 600,
    HRK: 200,
    BRL: 150,
    RSD: 2750,
};
export function maxPriceForFreeDelivery(currency) {
    return prices[currency];
}
